module.exports = __webpack_public_path__ + "static/media/doors.bd1b1f58.jpg";